import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Loader from '../../../common/Loader';
import CommonProductForm from './CommonProductForm';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { COMMON_PRODUCT_PATH } from '../../../../config/paths';
import {
  clearCommonProduct,
  getCommonProduct,
  putCommonProduct,
} from '../../../../actions/cargo';
import Content from '../../../layout/Content';

const EditCommonProduct = ({
  breadcrumbs,
  commonProduct,
  loading,
  match: {
    params: { id },
  },
  dispatchGetCommonProduct,
  dispatchClearCommonProduct,
  dispatchPutCommonProduct,
}) => {
  useEffect(() => {
    dispatchGetCommonProduct({ id });
    return () => {
      dispatchClearCommonProduct();
    };
  }, [id]);

  const onSubmit = (formValues) => {
    dispatchPutCommonProduct(id, formValues);
  };

  let content = null;

  const generateInitialValues = (product) => ({
    productName: product.get('productName'),
    productDescription: product.get('productDescription'),
    weight: product.get('weight'),
    height: product.get('height'),
    width: product.get('width'),
    length: product.get('length'),
    internalProduct: product.get('internalProduct'),
    active: product.get('active'),
    cargoCategory: {
      value: product.get('cargoCategory').id,
      label: product.get('cargoCategory').name,
    },
  });

  if (loading || commonProduct.isEmpty()) {
    content = <Loader />;
  } else {
    content = (
      <CommonProductForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(commonProduct)}
      />
    );
  }

  return (
    <Content
      title="Editar Producto Frecuente"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  );
};

EditCommonProduct.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetCommonProduct: PropTypes.func.isRequired,
  dispatchClearCommonProduct: PropTypes.func.isRequired,
  dispatchPutCommonProduct: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  commonProduct: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditCommonProduct.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { CargoUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Producto Frecuente',
      href: COMMON_PRODUCT_PATH,
    },
    {
      text: 'Ver',
      href: `${COMMON_PRODUCT_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  commonProduct: CargoUnit.CommonProduct.getIn(['current', 'content']),
  loading: CargoUnit.CommonProduct.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetCommonProduct: getCommonProduct,
  dispatchClearCommonProduct: clearCommonProduct,
  dispatchPutCommonProduct: putCommonProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCommonProduct);
